var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "R\\xE9teg_2",
    "data-name": "R\\xE9teg 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1280 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m821.78,373.52c14.25,14.49,14.34,33.13.06,47.5-20.15,20.3-40.43,40.47-60.65,60.7-60.91,60.91-121.84,121.79-182.68,182.76-6.78,6.79-14.41,10.03-23.71,6.77-3.29-1.15-6.49-3.39-8.99-5.87-39.25-39.08-78.41-78.24-117.53-117.46-14.11-14.15-14.06-32.91-.08-47.12,4.41-4.48,8.83-8.95,13.34-13.32,13.67-13.25,32.54-13.27,46.07.17,23.35,23.18,46.56,46.49,69.81,69.78,1.27,1.27,2.31,2.77,4.16,5.01,2.14-2.51,3.33-4.12,4.73-5.52,65.1-65.13,130.21-130.25,195.34-195.36,11.25-11.25,25.03-14.1,37.94-7.6,3.33,1.68,6.38,4.11,9.16,6.64,4.52,4.12,8.74,8.56,13.03,12.92Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.33abc9ed46f7dfb3d7663577ade49755.svg";
export { ForwardRef as ReactComponent };